<div
  class="ou-shared-button"
  [ngStyle]="{ font: font }"
  [class.red]="customColor === 'red'"
  [class.green]="customColor === 'green'"
  [class.yellow]="customColor === 'yellow'"
  [class.inverz]="inverz"
  [style.width]="fullWidth ? '100%' : 'auto'"
  [class.disabled]="disabled"
>
  <div *ngIf="title" [style.font-size]="font" [style.width]="fullWidth ? '100%' : 'auto'" [style.line-height]="size" class="ou-shared-button-title">{{title}}</div>
  <mat-icon
    *ngIf="icon"
    class="material-icons-outlined"
    [ngStyle]="{ width: size, height: size, 'font-size': size }"
  >{{icon}}</mat-icon>
</div>
